import { z } from 'zod';

export const updateTrainingParamsSchema = z.object({
  training_id: z.string().uuid('Invalid training ID'),
});

export const updateTrainingSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters').optional(),
  description: z.string().min(1, 'Description is required').optional(),
  content: z.string().min(1, 'Content is required').optional(),
  duration: z.string().min(1, 'Duration is required').optional(),
  video_url: z.url('Invalid video URL').optional(),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
});

export type UpdateTrainingParamsPayload = z.infer<typeof updateTrainingParamsSchema>;
export type UpdateTrainingPayload = z.infer<typeof updateTrainingSchema>;
